import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  useCancelSubscriptionMutation,
  useGetCurrentSubscriptionQuery,
} from "@/services/api/entities/payment";
import { useModal } from "@/features/modals/lib";
import { useAlert } from "@/shared/hooks";
import { appRouterPaths } from "@/services/navigation";

export const useSubscriptionBlock = () => {
  const { t } = useTranslation();
  const { showModal, hideModal, isModalOpen } = useModal();
  const {
    showModal: showHistoryModal,
    hideModal: hideHistoryModal,
    isModalOpen: isHistoryModalOpen,
  } = useModal();
  const { callSuccess, callError } = useAlert();
  const navigate = useNavigate();

  const { data, isLoading: profileIsLoading } = useGetCurrentSubscriptionQuery();

  const [cancelSubscription, { isLoading: cancelSubscriptionIsLoading }] =
    useCancelSubscriptionMutation();

  const handleClickUnsubscribe = useCallback(() => {
    showModal();
  }, [showModal]);

  const handleCancelSubscription = useCallback(async () => {
    try {
      await cancelSubscription().unwrap();
      callSuccess({ text: t("settingsPage.general.subscription.unsubscribeSuccess") });
    } catch (error) {
      callError({ text: t("apiErrors.unknown") });
    }

    hideModal();
  }, [cancelSubscription, hideModal, callSuccess, t]);

  const handleClickRenew = useCallback(() => {
    navigate(appRouterPaths.renewSubscription, { state: { fromSettings: true } });
  }, [navigate]);

  return {
    state: {
      subscription: data,
      isLoading: profileIsLoading,
      isModalOpen,
      cancelSubscriptionIsLoading,
      disabledUnsubscribe: data?.markedForCancellation,
      isHistoryModalOpen,
    },
    methods: {
      handleClickUnsubscribe,
      hideModal,
      handleCancelSubscription,
      handleClickRenew,
      showHistoryModal,
      hideHistoryModal,
    },
  };
};
